import styles from "./Invoice.module.scss";
import Right from "../../../../AdminAssets/svg/Right.svg";
import { Grid2 } from "@mui/material";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { ReactComponent as Rocon } from "../../../../AdminAssets/svg/Rocon123.svg";
import { ReactComponent as Left } from "../../../../AdminAssets/svg/Left.svg";
import { useSelector } from "react-redux";
import { formatDateInv } from "../../../../../../Utils/utils";
import { useEffect } from "react";
import { Actions } from "../../../../../../redux/constants/actionTypes";
import { getStore } from "../../../../../../Utils/storeUtils";
import DownloadIcon from "@mui/icons-material/Download";
import { useLocation } from "react-router-dom";

export default function Invoice() {
  const location = useLocation();
  const { invoiceHistory } = location.state || {};

  const selectedOrg = useSelector(
    (state) => state.organizationsInfo?.selectedOrg
  );

  useEffect(() => {
    getStore().dispatch({
      type: Actions.GET_INVOICE_HISTORY,
      orgId: selectedOrg?.orgId,
    });
  }, [selectedOrg]);

  // const cashfree = useSelector((state) => state.paymentInfo?.invoiceHistory);

  if (!invoiceHistory || invoiceHistory.length === 0) {
    return <div>Loading invoice data...</div>; // Graceful fallback
  }

  // Filter plans (if planCashFreeInvoiceList is null, fallback to [])
  const filteredPlans =
    invoiceHistory?.planCashFreeInvoiceList?.filter(
      (item) => item.planName !== "Waf"
    ) || [];

  let isBasePlan = false;

  const totalSubTotal = isBasePlan
    ? invoiceHistory?.planCashFreeInvoiceList[0]?.price
    : filteredPlans?.reduce(
        (acc, plan) => acc + parseFloat(plan.subTotal || 0),
        0
      );

  const generatePDF = () => {
    const input = document.getElementById("pdf-content");
    html2canvas(input)
      .then((canvas) => {
        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF({
          orientation: "portrait",
          unit: "mm",
          format: "a4",
        });

        const a4Width = 210;
        const imgHeight = (canvas.height * a4Width) / canvas.width;

        pdf.addImage(imgData, "PNG", 0, 0, a4Width, imgHeight);
        pdf.save("download.pdf");
      })
      .catch((err) => {
        console.error("Error generating PDF", err);
      });
  };

  return (
    <>
      <Grid2 className={styles.invoiceContainer}>
        <Grid2 id="pdf-content" className={styles.mainContainer}>
          <Grid2 className={styles.logoContainer}>
            <Rocon />
            <Grid2 className={styles.add}>
              By GlobalTek Yantra Private Limited
            </Grid2>
          </Grid2>
          <Left className={styles.leftIcon} />
          <Grid2 className={styles.invoiceHeader}>ROCON - INVOICE</Grid2>

          <Grid2 className={styles.left}>
            <Grid2 className={styles.display}>
              <Grid2 className={styles.id}>Receipt no :</Grid2>
              <Grid2 className={styles.id1}>{invoiceHistory?.invoiceId}</Grid2>
            </Grid2>
            <Grid2 className={styles.display}>
              <Grid2 className={styles.id}>Date :</Grid2>
              <Grid2 className={styles.id1}>
                {formatDateInv(invoiceHistory?.invoiceDate)}
              </Grid2>
            </Grid2>
          </Grid2>

          <Grid2 className={styles.displayCustomer}>
            <Grid2 className={styles.id}>Customer :</Grid2>
            <Grid2>
              <Grid2 className={styles.id1}>
                <b>{invoiceHistory?.userName}</b>
              </Grid2>
              <Grid2 className={styles.id1}>{invoiceHistory?.userEmail}</Grid2>
              <Grid2 className={styles.id1}>India</Grid2>
            </Grid2>
          </Grid2>

          <Grid2 className={styles.table}>
            <Grid2 className={styles.tableHeader}>Description</Grid2>
            <Grid2 className={styles.tableRight}>
              <Grid2 className={styles.tableHeader}>Qty</Grid2>
              <Grid2 className={styles.tableHeader}>Unit price</Grid2>
              <Grid2 className={styles.tableHeader}>Amount</Grid2>
            </Grid2>
          </Grid2>

          <hr className={styles.dotted} />

          {filteredPlans.map((plan, index) => (
            <Grid2 key={index} className={styles.tableDesc}>
              <Grid2>
                {plan.planName} - {invoiceHistory?.billingType}
              </Grid2>
              <Grid2 className={styles.tableDescRight}>
                <Grid2 className={styles.quantity}>{plan.quantity || 1}</Grid2>
                <Grid2>{plan.price || 0}</Grid2>
                <Grid2>{isBasePlan ? plan.price : plan.subTotal}</Grid2>
              </Grid2>
            </Grid2>
          ))}

          <hr className={styles.dotted1} />

          <Grid2 className={styles.taxes}>
            {invoiceHistory?.couponPrice && (
              <Grid2 className={styles.display}>
                <Grid2>Coupon Discount</Grid2>
                <Grid2>{invoiceHistory?.couponPrice}</Grid2>
              </Grid2>
            )}
            <Grid2 className={styles.display}>
              <Grid2>Subtotal</Grid2>
              <Grid2>{totalSubTotal}</Grid2>
            </Grid2>
            <Grid2 className={styles.display}>
              <Grid2>IGST 18%</Grid2>
              <Grid2>{parseFloat(invoiceHistory?.gstPrice).toFixed(2)}</Grid2>
            </Grid2>
          </Grid2>

          <hr className={styles.dotted1} />

          <Grid2 className={styles.displayTotal}>
            <Grid2>Total</Grid2>
            <Grid2>
              {(
                parseFloat(totalSubTotal || 0) +
                parseFloat(totalSubTotal || 0) * 0.18
              ).toFixed(2)}
            </Grid2>
          </Grid2>

          <Grid2
            className={`${styles.descr} ${
              invoiceHistory?.couponPrice ? styles.height : ""
            }`}
          >
            <img className={styles.rightIcon} src={Right} alt="Right" />
            <hr className={styles.dotted} />
            <Grid2 className={styles.desc}>
              If you have any questions, please contact:{" "}
              <b>support@roconpaas.com</b>
            </Grid2>
          </Grid2>
        </Grid2>

        <Grid2 className={styles.button}>
          <Grid2 onClick={generatePDF} className={styles.downloadButton}>
            Download
            <DownloadIcon />
          </Grid2>
        </Grid2>
      </Grid2>
    </>
  );
}
